module.exports = __webpack_public_path__ + "static/media/default-avatar.4491e84d.png";